(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gift-wrap-option"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.gift-wrap-option-block').forEach(function (block) {
  var checkbox = block.querySelector('.gift-wrap-option input[type="checkbox"]');
  var textarea = block.querySelector('.gift-wrap-option-message textarea');

  if (!checkbox || !textarea) return;

  function sync() {
    textarea.disabled = !checkbox.checked;
  }

  checkbox.addEventListener('change', sync);
  sync();
});
  } catch(e) { console.error(e); }
})();

})();
